import Icon from "@/components/Icon/Icon";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { TableCell } from "@/components/ui/table";
import { cn } from "@/lib/cn";
import type { CategoryData, TableRowData } from "./types";

interface CategoryCellProps {
  row: TableRowData;
  rowIndex: number;
  colIndex: number;
  largeCategory: CategoryData;
  mediumCategory: { code: string; name: string };
  hoveredRowIndex: number | null;
  hoveredColIndex: number | null;
  handleCellMouseEnter: (rowIndex: number, colIndex: number) => void;
  handleCellMouseLeave: () => void;
  isRowHovered?: boolean;
}

export const CategoryCell = ({
  row,
  rowIndex,
  colIndex,
  largeCategory,
  mediumCategory,
  hoveredRowIndex,
  hoveredColIndex,
  handleCellMouseEnter,
  handleCellMouseLeave,
  isRowHovered = false,
}: CategoryCellProps) => {
  const column = row.columns.find(
    (col) =>
      col.largeCategoryCode === largeCategory.code &&
      col.mediumCategoryCode === mediumCategory.code,
  );

  const isHovered =
    hoveredRowIndex === rowIndex && hoveredColIndex === colIndex;
  const isColHovered = hoveredColIndex === colIndex;

  return (
    <TableCell
      className={cn(
        "border-r p-2 text-center min-w-16",
        isHovered && "bg-neutral-gray-light-3",
        isRowHovered && !isHovered && "bg-neutral-gray-light-3",
        isColHovered && !isHovered && "bg-neutral-gray-light-3",
      )}
      onMouseEnter={() => handleCellMouseEnter(rowIndex, colIndex)}
      onMouseLeave={handleCellMouseLeave}
    >
      {column ? (
        <HStack className="gap-2 justify-center items-center">
          <div>
            <Text variant="label" className="text-success-on-neutral-fill">
              {column.inputFieldCount}
            </Text>
            <Text
              variant="labelSmallReg"
              className="text-neutral-muted-on-fill"
            >
              /{column.requiredFieldCount}
            </Text>
          </div>
          {column.hasIncludeFile && (
            <Icon iconName="Paperclip" colorVariant="primaryOnNeutralMuted" />
          )}
        </HStack>
      ) : (
        <Text variant="label" className="text-gray-300">
          -
        </Text>
      )}
    </TableCell>
  );
};
